
export default class backgroundManager{
    constructor(param){
      this.param = param;

      this.$bg;
      this.$lineWrap;
      this.$line2Wrap;
      this.$circleWrap;
      this.w = window.innerWidth;
      this.h = window.innerHeight;
      this.docH = document.getElementById("l-scroll").offsetHeight;

      this.lineSpeed = 7;
      this.unitSize;


    }
    init(pageID){
      let _this = this;

      this.$bg = document.querySelector('.l-bg');

      this.unitSize = this.w > 750 ? 90 : 66;

      this.lineSpeed = this.docH / 1700 * 10;
      // console.log(this.lineSpeed);


      window.onblur = function() { window.blurred = true;
      // console.log('blur',window.blurred)
      };
      window.onfocus = function() { window.blurred = false; };

    }
    resize(w,h){
      this.w = w;
      this.h = h;
      this.lineSpeed = this.docH / 1700 * 10;
      this.docH = document.getElementById("l-scroll").offsetHeight;
      this.unitSize = this.w > 750 ? 90 : 66;

    }


}
